/**
 * NutriHangar Testimonials — Bounce Engine v4
 * Mobile: dissolvenza con bounce, trascinamento orizzontale e indicatori.
 * L'autoplay cede il passo all'utente al primo tocco e non riprende piu'.
 * Desktop (>= 990px): griglia statica, nessuna logica attiva.
 */
(function() {

    const BREAKPOINT   = 990;   // sotto questa soglia la sezione diventa carosello
    const AUTOPLAY_MS  = 10000; // ritmo di rotazione automatica
    const DRAG_START_PX = 6;    // soglia oltre cui il tocco e' un trascinamento, non un tap
    const SWIPE_MIN_PX = 45;    // spostamento oltre il quale il gesto cambia card
    const FADE_MAX     = 0.5;   // opacita' minima raggiunta trascinando

    const initTestimonials = () => {
        document.querySelectorAll('.nh-testimonials').forEach(section => {

            // Un nodo gia' inizializzato non va riagganciato: shopify:section:load
            // rigenera il DOM, quindi il flag nasce e muore con l'elemento.
            if (section.dataset.nhTestimonialsReady === '1') return;

            const grid  = section.querySelector('.nh-testimonials__grid');
            const cards = Array.from(section.querySelectorAll('.nh-testimonial-card'));
            const totalSlides = cards.length;

            if (!grid || totalSlides === 0) return;
            section.dataset.nhTestimonialsReady = '1';

            let currentIndex = 0;
            let interval     = null;
            let userTookOver = false; // dopo il primo gesto l'autoplay resta spento

            const isMobileFn = () => window.innerWidth < BREAKPOINT;
            let isMobile = isMobileFn();

            /* Altezza contenitore.
               Le card sono in posizione assoluta: senza questo il grid
               collasserebbe. Si misura la piu' alta invece di fissare un
               valore, altrimenti una testimonianza lunga finisce tagliata
               dall'overflow:hidden della sezione. */
            const updateGridHeight = () => {
                if (!isMobile) {
                    grid.style.minHeight = '';
                    return;
                }
                let tallest = 0;
                cards.forEach(card => {
                    if (card.offsetHeight > tallest) tallest = card.offsetHeight;
                });
                if (tallest > 0) grid.style.minHeight = tallest + 'px';
            };

            /* Indicatori.
               Costruiti qui e non in Liquid: su desktop non servono e il
               numero dipende dai blocchi effettivamente presenti. */
            const dots = [];
            const buildDots = () => {
                if (totalSlides < 2) return;

                const nav = document.createElement('div');
                nav.className = 'nh-testimonials__dots';
                nav.setAttribute('role', 'tablist');
                nav.setAttribute('aria-label', 'Testimonianze');

                for (let i = 0; i < totalSlides; i++) {
                    const dot = document.createElement('button');
                    dot.type = 'button';
                    dot.className = 'nh-testimonials__dot';
                    dot.setAttribute('role', 'tab');
                    dot.setAttribute('aria-label', 'Testimonianza ' + (i + 1) + ' di ' + totalSlides);
                    dot.addEventListener('click', () => {
                        takeOver();
                        updateSlide(i);
                    });
                    nav.appendChild(dot);
                    dots.push(dot);
                }

                grid.insertAdjacentElement('afterend', nav);
            };

            const syncDots = () => {
                dots.forEach((dot, i) => {
                    const active = i === currentIndex;
                    dot.classList.toggle('is-active', active);
                    dot.setAttribute('aria-selected', active ? 'true' : 'false');
                });
            };

            // Aggiorna lo stato: solo is-active (no prev/next — bounce puro)
            const updateSlide = (index) => {
                if (index < 0) index = totalSlides - 1;
                if (index >= totalSlides) index = 0;
                currentIndex = index;

                cards.forEach((card, i) => {
                    card.classList.toggle('is-active', i === currentIndex);
                });

                syncDots();
                updateGridHeight();
            };

            const stopAutoPlay = () => {
                if (interval) {
                    clearInterval(interval);
                    interval = null;
                }
            };

            const startAutoPlay = () => {
                stopAutoPlay();
                if (!isMobile || userTookOver || totalSlides < 2) return;
                interval = setInterval(() => {
                    updateSlide(currentIndex + 1);
                }, AUTOPLAY_MS);
            };

            // Il controllo passa all'utente: la rotazione automatica non riparte
            const takeOver = () => {
                userTookOver = true;
                stopAutoPlay();
            };

            /* Trascinamento.
               La card segue il dito in tempo reale: e' quel riscontro
               immediato a dire all'utente che l'elemento e' interattivo.
               Il blocco dell'asse lo gestisce il CSS con touch-action:pan-y,
               quindi lo scorrimento verticale della pagina resta al browser
               e a noi arriva un pointercancel. */
            let pointerId = null;
            let startX    = 0;
            let deltaX    = 0;
            let dragging  = false; // diventa vero solo a movimento orizzontale accertato

            const activeCard = () => cards[currentIndex];

            const paintDrag = () => {
                const card = activeCard();
                if (!card) return;
                const fade = Math.min(Math.abs(deltaX) / 260, FADE_MAX);
                card.style.transform = 'translateX(' + deltaX + 'px)';
                card.style.opacity   = String(1 - fade);
            };

            const releaseDrag = (snapBack) => {
                const card = activeCard();
                section.classList.remove('is-dragging');
                if (!card) return;

                if (snapBack) {
                    // Ritorno morbido al centro quando il gesto non basta
                    card.style.transition = 'transform 0.28s ease, opacity 0.28s ease';
                    card.style.transform  = '';
                    card.style.opacity    = '';
                    window.setTimeout(() => { card.style.transition = ''; }, 300);
                } else {
                    // Cambio card: si ripulisce subito per lasciare il campo al bounce
                    card.style.transition = '';
                    card.style.transform  = '';
                    card.style.opacity    = '';
                }
            };

            const onPointerDown = (e) => {
                if (!isMobile || totalSlides < 2 || pointerId !== null) return;
                if (e.pointerType === 'mouse' && e.button !== 0) return;

                pointerId = e.pointerId;
                startX    = e.clientX;
                deltaX    = 0;
                dragging  = false;

                if (grid.setPointerCapture) {
                    try { grid.setPointerCapture(pointerId); } catch (err) { /* capture non disponibile */ }
                }
            };

            const onPointerMove = (e) => {
                if (pointerId === null || e.pointerId !== pointerId) return;
                deltaX = e.clientX - startX;

                /* Il gesto diventa un trascinamento solo dopo qualche pixel:
                   un tap o l'inizio di uno scorrimento verticale non devono
                   spegnere la rotazione automatica ne' tagliare il bounce. */
                if (!dragging) {
                    if (Math.abs(deltaX) < DRAG_START_PX) return;
                    dragging = true;
                    takeOver();
                    section.classList.add('is-dragging');
                    const card = activeCard();
                    if (card) card.style.transition = '';
                }

                paintDrag();
            };

            const onPointerUp = (e) => {
                if (pointerId === null || e.pointerId !== pointerId) return;

                const travelled = deltaX;
                const wasDragging = dragging;
                pointerId = null;
                deltaX    = 0;
                dragging  = false;

                if (!wasDragging) return; // era un tap: nessuno stato da ripristinare

                if (Math.abs(travelled) >= SWIPE_MIN_PX) {
                    releaseDrag(false);
                    updateSlide(currentIndex + (travelled < 0 ? 1 : -1));
                } else {
                    releaseDrag(true);
                }
            };

            const onPointerCancel = (e) => {
                if (pointerId === null || e.pointerId !== pointerId) return;
                const wasDragging = dragging;
                pointerId = null;
                deltaX    = 0;
                dragging  = false;
                if (wasDragging) releaseDrag(true);
            };

            grid.addEventListener('pointerdown',        onPointerDown);
            grid.addEventListener('pointermove',        onPointerMove);
            grid.addEventListener('pointerup',          onPointerUp);
            grid.addEventListener('pointercancel',      onPointerCancel);
            grid.addEventListener('lostpointercapture', onPointerCancel);

            // Un trascinamento col mouse non deve diventare un drag nativo
            grid.addEventListener('dragstart', (e) => e.preventDefault());

            // Reset per desktop
            const resetState = () => {
                stopAutoPlay();
                cards.forEach(card => {
                    card.classList.remove('is-active');
                    card.style.transform  = '';
                    card.style.opacity    = '';
                    card.style.transition = '';
                });
                section.classList.remove('is-dragging');
                grid.style.minHeight = '';
            };

            // Responsive switch
            const checkResponsive = () => {
                const mobileNow = isMobileFn();
                if (mobileNow !== isMobile) {
                    isMobile = mobileNow;
                    if (isMobile) {
                        updateSlide(0);
                        startAutoPlay();
                    } else {
                        resetState();
                    }
                } else if (isMobile) {
                    // Rotazione del telefono: il testo si ridispone, l'altezza cambia
                    updateGridHeight();
                }
            };

            window.addEventListener('resize', checkResponsive);

            // Boot
            buildDots();
            if (isMobile) {
                updateSlide(0);
                startAutoPlay();
            }

            // I font arrivano dopo il primo paint e cambiano l'altezza del testo
            window.addEventListener('load', updateGridHeight);

            // Shopify Editor Support
            if (typeof Shopify !== 'undefined' && Shopify.designMode) {
                if (isMobile) {
                    window.setTimeout(() => updateSlide(0), 100);
                }
            }
        });
    };

    document.addEventListener('DOMContentLoaded', initTestimonials);

    document.addEventListener('shopify:section:load', (e) => {
        if (e.target.querySelector('.nh-testimonials')) {
            initTestimonials();
        }
    });

})();
